module.exports = __webpack_public_path__ + "97339e2763c2cbdb2f5daa8f1b9ab1cb.png";